import React, { useEffect, useState } from 'react';
import CustomerAccess from './CustomerAccess';
import { useInfiniteCustomersByResellerQuery } from 'lib/api/customers/useInfiniteCustomersByResellerQuery';
import { useAuth } from 'lib/context';
import { Customer } from 'lib/api/superadmin/customersQuery';

interface ICustomerFormProps {
  resellerId: number;
  isResellerAdmin: boolean;
}

const CustomersForm = ({ resellerId, isResellerAdmin }: ICustomerFormProps) => {
  const [customers, setCustomers] = useState<Customer[]>([]); // main customer data
  const { userData } = useAuth();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const { data, isFetching, isLoading } = useInfiniteCustomersByResellerQuery({
    params: {
      customerId: Number(userData.customerId),
      take: 50,
      skip: page,
      search,
    },
    enabled: isResellerAdmin && !!resellerId && resellerId !== 0,
  });

  const pageData = data?.pages[0]?.customers || [];
  const count = Number(data?.pages[0]?.count) || 0;
  const displayedCount =
    data?.pages?.reduce((acc, page) => acc + page?.customers?.length || 0, 0) ||
    0;

  useEffect(() => {
    if (pageData.length) {
      const customerData = pageData || [];
      const aggregatedData = [...customers, ...customerData];
      const customerArray =
        count <= customerData.length ? customerData : aggregatedData;

      setCustomers(customerArray);
    }
  }, [pageData]);

  return (
    <CustomerAccess
      customers={customers}
      resellerId={resellerId}
      isShareWithResellerSelected={false}
      onToggleResellerFlag={() => {}}
      isFetching={isFetching}
      isLoading={isLoading}
      count={count}
      displayedCount={displayedCount}
      isResellerAdmin={isResellerAdmin}
      setPage={setPage}
      setSearch={setSearch}
      setCustomers={setCustomers}
    />
  );
};

export default React.memo(CustomersForm);
